import { Warning, ArrowLeft, PaperPlaneTilt, X } from "@phosphor-icons/react";
import { useEscClose } from "@/lib/useEscClose";

export default function MissingInfoModal({ missing, saving, onBack, onContinue }) {
  useEscClose(onBack);
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onBack}>
      <div className="bg-white border-2 border-black w-full max-w-lg max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="missing-info-modal">
        <div className="border-b-2 border-black p-4 flex items-center justify-between bg-[#FFC000]">
          <div className="flex items-center gap-2">
            <Warning size={20} weight="fill" />
            <span className="overline font-bold">INFORMAÇÕES FALTANDO</span>
          </div>
          <button onClick={onBack} data-testid="missing-close-btn"><X size={20} /></button>
        </div>
        <div className="p-5">
          <p className="text-sm mb-4">
            Este pedido ainda <strong>não tem todas as informações de produção</strong> preenchidas:
          </p>
          <div className="space-y-3 mb-5">
            {missing.map((m) => (
              <div key={m.sku} className="border border-zinc-300 p-3" data-testid={`missing-item-${m.sku}`}>
                <div className="flex items-baseline gap-2 flex-wrap mb-1.5">
                  <span className="font-mono font-bold">{m.sku}</span>
                  {m.name && <span className="text-xs text-zinc-500 truncate">{m.name}</span>}
                </div>
                <div className="flex gap-1.5 flex-wrap">
                  {m.missing.map((f) => (
                    <span key={f} className="text-[10px] font-bold uppercase tracking-widest bg-red-50 border border-[#E60000] text-[#E60000] px-2 py-1">
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <button onClick={onBack} className="btn btn-ghost flex-1 py-3" data-testid="missing-back-btn">
              <ArrowLeft size={16} weight="bold" /> Voltar para Completar
            </button>
            <button onClick={onContinue} disabled={saving} className="btn flex-1 py-3" data-testid="missing-continue-btn">
              <PaperPlaneTilt size={16} weight="bold" /> Continuar mesmo Assim
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
